import { WarningIcon } from "../icons"
import { Toasts } from "./toasts"

const el = {
  root: document.querySelector<HTMLButtonElement>('.batch-order'),
  addSingleLineButton: document.querySelector<HTMLButtonElement>('#batch-order-add-single-line'),
  addLinesButton: document.querySelector<HTMLButtonElement>('#batch-order-add-lines'),
  addToCartButton: document.querySelector<HTMLButtonElement>('#batch-order-add-to-cart'),
  clearCartButton: document.querySelector<HTMLButtonElement>('#batch-order-clear-cart'),
  textarea: document.querySelector<HTMLTextAreaElement>('#batch-order-textarea'),
  form: document.querySelector<HTMLFormElement>('.batch-order__form'),
  inputsContainer: document.querySelector<HTMLDivElement>('.batch-order__inputs'),
  cartButton: document.querySelector<HTMLButtonElement>('#cart-button'),
}

export const BatchOrder = {

  init: () => {
    if (!el.root) return
    if (el.addSingleLineButton) el.addSingleLineButton.addEventListener('click', () => BatchOrder.addLine({}))
    if (el.addLinesButton) el.addLinesButton.addEventListener('click', BatchOrder.handleTextarea)
    if (el.form) el.form.addEventListener('submit', BatchOrder.onFormSubmit)
    if (el.clearCartButton) el.clearCartButton.addEventListener('click', BatchOrder.clearCart)
  },

  addLine: ({ sku = '', quantity = ''}) => {
    if (!el.inputsContainer) return
    const numberOfLines = Math.ceil(document.querySelectorAll<HTMLInputElement>('.batch-order__inputs input').length / 2)
    const html =  BatchOrder.generateLineHtml({index: numberOfLines, sku, quantity })
    el.inputsContainer.insertAdjacentHTML('beforeend', html)
  },

  handleTextarea: () => {
    if (!el.textarea) return
    const { skuInputs, quantityInputs } = BatchOrder.getInputs()

    el.textarea.value
      .split(';')
      .filter(x => x)
      .forEach(combo => {
        const [sku, quantity] = combo.split(',')

        const skuAlreadyExists = skuInputs.find(x => x.value === sku)
        if (skuAlreadyExists) return

        // if there is a free line we fill that line, otherwise we add new line
        const emptyInputIndex = skuInputs.findIndex(x => x.name === 'sku' && !x.value)
        if (emptyInputIndex >= 0) {
          const skuInput = skuInputs[emptyInputIndex]
          const quantityInput = quantityInputs[emptyInputIndex]
          skuInput.value = sku
          if (quantityInput) quantityInput.value = quantity
          return
        }

        BatchOrder.addLine({ sku, quantity })
      })

    el.textarea.value = ''
  },

  onFormSubmit: async (e: Event) => {
    e.preventDefault()

    const data = BatchOrder.getFormData()
    if (!data.length) {
      Toasts.addToast({
        title: 'Villa kom upp!',
        text:  'Þú átt eftir að bæta við vörum.',
        icon: WarningIcon(),
      })
      return
    }

    if (el.addToCartButton) {
      el.addToCartButton.disabled = true
      el.addToCartButton.classList.add('button--loading')
    }

    try {
      const response = await fetch(`/umbraco/surface/orders/BulkAddToCart`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      })

      if (response.status !== 200) throw Error('')
      const { success } = await response.json()
      if (!success) throw Error('')

      BatchOrder.resetForm()
      el.cartButton && el.cartButton.click()
    } catch (_) {
      Toasts.addToast({
        title: 'Villa kom upp!',
        text:  'Ekki tókst að bæta vörum við í körfu.',
        icon: WarningIcon(),
      })
    }

    if (el.addToCartButton) {
      el.addToCartButton.disabled = false
      el.addToCartButton.classList.remove('button--loading')
    }
  },

  resetForm: () => {
    if (!el.inputsContainer || !el.textarea) return
    el.inputsContainer.innerHTML = `
      ${BatchOrder.generateLineHtml({index: 0})}
      ${BatchOrder.generateLineHtml({index: 1})}
      ${BatchOrder.generateLineHtml({index: 2})}
      ${BatchOrder.generateLineHtml({index: 3})}
    `
    el.textarea.value = ''
  },

  getFormData: () => {
    const { skuInputs, quantityInputs } = BatchOrder.getInputs()

    let data = []
    skuInputs.forEach((item, i) => {
      const sku = item.value
      const quantity = parseInt(quantityInputs[i]?.value)
      if (!sku || isNaN(quantity)) return
      data.push({ Sku: sku, Quantity: quantity })
    }, [])

    return data
  },

  generateLineHtml: ({ index = 0, sku = '', quantity = '' }) => `
    <div class="input">
      <label for="sku${index + 1}" class="input__label">Vörunúmer</label>
      <input id="sku${index + 1}" class="input__input" type="text" placeholder="Sláðu inn vörunúmer" name="sku" value="${sku}">
    </div>
    <div class="input">
      <label for="quantity${index + 1}" class="input__label">Magn</label>
      <input id="quantity${index + 1}" class="input__input" type="number" placeholder="Sláðu inn magn" name="quantity" value="${quantity}">
    </div>
  `,

  getInputs: () => {
    const skuInputs = Array.from(document.querySelectorAll<HTMLInputElement>('.batch-order__inputs input[name="sku"]'))
    const quantityInputs = Array.from(document.querySelectorAll<HTMLInputElement>('.batch-order__inputs input[name="quantity"]'))
    return { skuInputs, quantityInputs }
  },

  clearCart: async  () => {

    el.clearCartButton.disabled = true
    el.clearCartButton.classList.add('button--loading')

    try {

        const response = await fetch(`/umbraco/surface/orders/clearcart`, {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json'
          },
        })
  
        if (response.status !== 200) throw Error('')
        const { success } = await response.json()
        if (!success) throw Error('')

        BatchOrder.resetForm()

    } catch (_) {
      Toasts.addToast({
        title: 'Villa kom upp!',
        text:  'Ekki tókst að Hreinsa körfu.',
        icon: WarningIcon(),
      })
    }

    el.clearCartButton.disabled = false
    el.clearCartButton.classList.remove('button--loading')
  }
}